import styled from 'styled-components'

export const ButtonV2 = styled.button`
  background: ${({ theme: { colors }, variant }) => (variant ? colors[variant] : colors.primary)};
  color: ${({ theme: { colors } }) => colors.white};
  border: none;
  padding: ${({ theme: { spaces } }) => `${spaces.small} ${spaces.medium}`};
  font-weight: bold;
  box-shadow: 0px 0px 8px rgba(81, 81, 81, 0.2) 0px 0px 8px;
  cursor: pointer;
  outline: none;
  transition: box-shadow 0.3s ease-in;
  :hover {
    box-shadow: ${({ theme: { colors } }) => colors.primary} 0px 0px 3px;
  }
  margin: ${({ theme: { spaces } }) => spaces.small};
  @media (min-width: 600px) {
    padding: ${({ theme: { spaces } }) => `${spaces.medium} ${spaces.larger}`};
    font-size: ${({ theme: { fontSizes } }) => fontSizes.medium};
    margin-top: ${({ theme: { spaces } }) => spaces.large};
  }
`
export const AnchorButton = styled.a`
  display: block;
  background: ${({ theme: { colors }, variant }) => (variant ? colors[variant] : colors.primary)};
  color: ${({ theme: { colors } }) => colors.white};
  border: none;
  padding: ${({ theme: { spaces } }) => `${spaces.small} ${spaces.medium}`};
  font-weight: bold;
  box-shadow: 0px 0px 8px rgba(81, 81, 81, 0.2) 0px 0px 8px;
  cursor: pointer;
  outline: none;
  transition: box-shadow 0.3s ease-in;
  :hover {
    box-shadow: ${({ theme: { colors } }) => colors.primary} 0px 0px 3px;
  }
  margin: ${({ theme: { spaces } }) => spaces.small};
  text-decoration: none;
  @media (min-width: 600px) {
    padding: ${({ theme: { spaces } }) => `${spaces.medium} ${spaces.larger}`};
    font-size: ${({ theme: { fontSizes } }) => fontSizes.medium};
    margin-top: ${({ theme: { spaces } }) => spaces.large};
  }
  align-self: center;
  justify-self: center;
  text-align: center;
  max-width: 300px;
  margin: auto;
`

export const test = styled.div``

export const SubscribeButton = styled.button`
  outline: none;
  cursor: pointer;
  color: ${({ theme: { colors } }) => colors.white};
  background: ${({ theme: { colors } }) => colors.primary};
  border: none;
  border-radius: 0.3rem;
  margin: 1rem;
  padding: 0.4rem 0rem;
  width: 6rem;
  white-space: nowrap;
  :hover {
    background: ${({ theme: { colors } }) => colors.darkGreen};
  }
  @media (max-width: 818px) {
    margin: 0.5rem 1rem 1rem;
  }
  @media (max-width: 599px) {
    margin-bottom: 0rem;
  }
`
